<template>
  <div class="regist-choose-org">
    <div class="title">请选择您所在的组织机构</div>
    <div class="search-container" @click="handleJumpSearch">
      <div class="search">
        <i class="iconfont icon-search-1"></i>
        <span>搜索机构名称</span>
      </div>
    </div>
    <main>
      <regisTree @getChildren="getChildren" :data="treeData"></regisTree>
    </main>
    <div class="next-btn">
      <div @click="handleNext" class="btn" :class="{active: registInfo.orgInfo.id}">
        下一步
      </div>
    </div>
  </div>
</template>

<script>
import {getAllorg, applyToOrg} from '@/api'
import regisTree from './regisTree'
export default {
  components: {
    regisTree
  },
  data() {
    return {
      // searchValue: '',
      treeData: [],
      registInfo: {
        orgInfo: '',
        verifyId: '',
        phone: '',
        openAccountId: ''
      }
    }
  },
  created() {
    const {phone, verifyId, openAccountId} = this.$route.query
    this.registInfo.verifyId = verifyId
    this.registInfo.phone = phone
    this.registInfo.openAccountId = openAccountId
    this.getOrgs(0)
  },
  methods: {
    handleJumpSearch() {
      const query = this.$route.query
      this.$router.push({
        path: '/registSearchOrg',
        query: query
      })
    },
    handleNext() {
      if (!this.registInfo.orgInfo.id) {
        return this.$Toast.fail('请选择机构')
      }
      // 存在已注册机构
      if (this.registInfo.openAccountId) {
        const params = {
          openAccountId: this.registInfo.openAccountId,
          orgId: this.registInfo.orgInfo.id
        }
        applyToOrg(params).then(res => {
          if (res.success) {
            localStorage.clear()
            this.$router.push({
              path: '/success',
              query: {type: 3}
            })
          } else {
            this.$Toast.fail(res.msg)
          }
        })
      } else {
        localStorage.setItem('registInfo', JSON.stringify(this.registInfo))
        this.$router.push('/registSetName')
      }
    },
    // =================
    getChildren(item) {
      this.resetActive(this.treeData)
      item.active = true
      this.registInfo.orgInfo = {id: item.id, displayName: item.displayName, unitAttr: item.unitAttr}
      if (item.next && !item.children.length) {
        this.getOrgs(item.id)
      } else {
        item.defaultOpen = !item.defaultOpen
      }
    },
    getOrgs(pId) {
      const params = {
        parentId: pId,
        onlyOrg: 1,
        level: 1
      }
      getAllorg(params).then(res => {
        if (pId === 0) {
          let data = res.data
          data = data.map(item => ({...item, active: false, defaultOpen: false}))
          this.treeData = data
        } else {
          if (res.data.length) {
            let data = res.data
            data = data.map(item => ({...item, active: false, defaultOpen: false}))
            this.setTargetChildren(this.treeData, pId, data)
          }
        }
      })
    },
    setTargetChildren(targetArr, targetId, children) {
      for (const item of targetArr) {
        if (item.id === targetId) {
          item.children = children
          item.defaultOpen = true
          return
        }
        if (item.children && item.children.length) {
          this.setTargetChildren(item.children, targetId, children)
        }
      }
    },
    resetActive(targetArr) {
      for (const item of targetArr) {
        item.active = false
        if (item.children && item.children.length) {
          this.resetActive(item.children)
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.regist-choose-org {
  padding: 16px 16px 50px 16px;
  height: 100vh;
  background: #fff;
}
.title {
  color: #909399;
  font-size: 14px;
}
.search-container {
  display: flex;
  align-items: center;
  width: 100%;
  height: 48px;
  .search {
    display: flex;
    align-items: center;
    width: 100%;
    height: 32px;
    padding: 0 16px;
    box-sizing: border-box;
    background: #f5f5f5;
    border-radius: 18px;
    i {
      color: #b3b3b3;
    }
    span {
      margin-left: 7px;
      font-size: 14px;
      color: #b3b3b3;
    }
  }
}
main {
  height: calc(100vh - 240px + 74px);
  overflow-y: scroll;
  margin-left: -20px;
}
main::-webkit-scrollbar {
  display: none;
}
.next-btn {
  position: absolute;
  width: 100%;
  left: 0;
  bottom: 0;
  padding: 12px 16px;
  height: 68px;
  background: #fff;
  color: #fff;
  text-align: center;
  box-sizing: border-box;
  .btn {
    width: 100%;
    height: 100%;
    font-size: 16px;
    line-height: 48px;
    border-radius: 1000px;
    background: rgba(#007aff, 0.4);
    &.active {
      background: rgba(#007aff, 1);
    }
  }
}
</style>
<style lang="scss">
.regist-choose-org .van-search {
  padding: 20px 0;
}
</style>
